/**
 * Surface has committed frames that expect video, but no paint-ready video element
 * (readyState / decode). Distinct from empty_playback_surface (brand cube).
 */
export const VIDEO_PAINT_STALL_FAULT_MS = 10_000

export interface IVideoPaintStallDetectInput {
  documentVisible: boolean
  queueLength: number
  surfaceFrameCount: number
  visibleFrameExpectsVideo: boolean
  /** Continuous stall while video expected but not paint-ready; null when not in that mode. */
  videoPaintStallMs: number | null
  suppressBecauseRegistrationResync: boolean
  suppressBecauseRegistrationTransitionHold: boolean
  weeklyAvailabilitySuppressed: boolean
  thresholdMs?: number
}

export interface IVideoPaintStallStatus {
  suspected: boolean
  stallMs: number
}

export function detectVideoPaintStall(input: IVideoPaintStallDetectInput): IVideoPaintStallStatus {
  const thresholdMs = input.thresholdMs ?? VIDEO_PAINT_STALL_FAULT_MS
  if (
    !input.documentVisible
    || input.weeklyAvailabilitySuppressed
    || input.queueLength < 1
    || input.surfaceFrameCount < 1
    || !input.visibleFrameExpectsVideo
    || input.videoPaintStallMs == null
    || input.suppressBecauseRegistrationResync
    || input.suppressBecauseRegistrationTransitionHold
  ) {
    return { suspected: false, stallMs: 0 }
  }
  const stallMs = Math.max(0, input.videoPaintStallMs)
  if (stallMs < thresholdMs) {
    return { suspected: false, stallMs: 0 }
  }
  return { suspected: true, stallMs }
}
